import { usePermission } from '@backstage/plugin-permission-react';
import {
  portalgroupsReadPermission,
  portalgroupsCreatePermission,
  portalgroupsUpdatePermission,
  portalgroupsDeletePermission,
} from '@internal/backstage-plugin-portalgroups-common';

/**
 * Resolves all portalgroups RBAC permissions through the permission backend so
 * components don't need to repeat the `usePermission` calls and aggregate their
 * loading/error state by hand.
 */
export const usePortalgroupsPermissions = (): {
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  loading: boolean;
  error?: Error;
} => {
  const {
    allowed: canRead,
    loading: loadingRead,
    error: readError,
  } = usePermission({ permission: portalgroupsReadPermission });
  const {
    allowed: canCreate,
    loading: loadingCreate,
    error: createError,
  } = usePermission({ permission: portalgroupsCreatePermission });
  const {
    allowed: canUpdate,
    loading: loadingUpdate,
    error: updateError,
  } = usePermission({ permission: portalgroupsUpdatePermission });
  const {
    allowed: canDelete,
    loading: loadingDelete,
    error: deleteError,
  } = usePermission({ permission: portalgroupsDeletePermission });

  return {
    canRead,
    canCreate,
    canUpdate,
    canDelete,
    loading: loadingRead || loadingCreate || loadingUpdate || loadingDelete,
    error: readError || createError || updateError || deleteError,
  };
};
